module.exports = __webpack_public_path__ + "img/a.dc6dd827.jpg";